/**
 * Resolves the IANA timezone of the runtime (browser in production, jsdom in
 * tests). Returns the provided fallback when Intl is unavailable, which keeps
 * SSR contexts and older Node test environments safe.
 *
 * Note: the value is resolved on every call so a session that changes OS
 * timezone picks up the new value on the next call.
 */
const DEFAULT_FALLBACK = 'America/Chicago';

export const getBrowserTimezone = (fallback = DEFAULT_FALLBACK) => {
  if (typeof Intl === 'undefined' || !Intl.DateTimeFormat) {
    return fallback;
  }
  return Intl.DateTimeFormat().resolvedOptions().timeZone || fallback;
};
